export const AVATAR_SIZE_BY_CONTENT_SIZE_MAP = {
    "13": "16",
    "13b": "16",
    "15": "20",
    "15b": "20",
} as const;

export const PICTURE_SIZE_BY_CONTENT_SIZE_MAP = {
    "13": "16",
    "13b": "16",
} as const;

export const ICON_SIZE_BY_CONTENT_SIZE_MAP = {
    "13": "16",
    "13b": "16",
    "15": "20",
    "15b": "20",
    "17": "24",
    "17b": "24",
    "21b": "24",
    "27b": "24",
    "56b": "48",
} as const;

export const CONTENT_SIZE_BY_ICON_SIZE_MAP = {
    "16": ["13", "13b"],
    "20": ["15", "15b"],
    "24": ["17", "17b", "21b", "27b"],
    "48": ["56b"],
};

export const BADGE_SIZE_BY_CONTENT_SIZE_MAP = {
    "13": "16",
    "13b": "16",
    "15": "16",
    "15b": "16",
    "17": "20",
    "17b": "20",
    "21b": "24",
    "27b": "24",
    "56b": "24",
} as const;

export const LINK_SIZE_BY_CONTENT_SIZE_MAP = {
    "13": "13",
    "15": "15",
    "17": "17",
} as const;

export const TAG_SIZE_BY_CONTENT_SIZE_MAP = {
    "13": "20",
    "13b": "20",
    "15": "20",
    "15b": "20",
    "17": "20",
    "17b": "20",
    "21b": "24",
    "27b": "24",
    "56b": "24",
} as const;

export const TEXT_SIZE_BY_CONTENT_SIZE_MAP = {
    "13": "13",
    "13b": "13",
    "15": "15",
    "15b": "15",
    "17": "17",
    "17b": "17",
    "21b": "21",
    "27b": "27",
    "56b": "56",
} as const;

export const TEXT_MIXIN_BY_CONTENT_SIZE_MAP = {
    "13": "caption-m",
    "13b": "caption-m-accent",
    "15": "body-m",
    "15b": "title-s",
    "17": "body-l",
    "17b": "title-m",
    "21b": "title-l",
    "27b": "title-xl",
    "56b": "display-xl",
    custom: "custom",
} as const;
